<template lang="pug">
#header-container
    #header.fixed-top(:style='aplicarZindex()')
        #logo-wrapper
            img#logo-lyra(src='@/assets/lyra-logo.svg')
        #send-button(v-if='modoExibicao === "visao-trilha"')
            el-button.primary-button.btn-enviar-trilha(
                icon='el-icon-position',
                type='primary',
                size='small',
                @click='dispararTrilha()'
            ) {{ $t('mensagens.pssc.telaVisualizarTrilha.btnEnviarTrilha') }}
</template>

<script>
import PSSCPublicService from '@/services/PSSCPublicService';

export default {
    name: 'MenuSuperiorTrilhaPssc',

    data() {
        return {
            user: {
                nome: '',
                nameGroup: '',
                perfil: '',
                locale: '',
                id: '',
                paisGrupo: '',
                grupos: []
            }
        };
    },

    props: {
        route: {
            type: String
        },
        routeParams: {
            type: Object,
            required: false
        },
        modoExibicao: {
            type: String,
            required: true
        },
        idTerritorio: {
            type: String,
            required: false
        },
        idUsuarioLogado: {
            type: String,
            required: false
        }
    },
    created() {
        document.title = 'Lyra';
        const link = document.querySelector('[rel=\'icon\']');
        link.setAttribute('href', '/lyra-favicon/favicon3.ico');
    },
    methods: {
        async dispararTrilha() {
            try {
                await PSSCPublicService.dispararTrilha({
                    idTerritorio: this.idTerritorio,
                    idUsuarioLogado: this.idUsuarioLogado
                }).then(() => {
                    this.$notify.success({
                        message: this.$t('mensagens.pssc.telaVisualizarTrilha.sucessoFilaEnvio')
                    });
                });
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.pssc.telaVisualizarTrilha.erroEnvioTrilha')
                });
            }
        },

        aplicarZindex() {
            return { 'z-index': '3001' };
        }
    }
};
</script>

<style lang="scss" scoped>
$width-box-tipo-cultura: 115px;

#language-dropdown {
    color: var(--white);
    margin-right: 15px;
    margin-left: auto;
    width: auto;
    display: flex;
    align-items: center;
    cursor: pointer;

    span.language-name {
        color: white;
        font-size: 14px;
        margin-right: 4px;
    }
}

#header {
    height: 65px;
    background-color: var(--primary);
    box-shadow: 0px 3px 5px 0px var(--block-shadow);
    display: flex;
    justify-content: space-between;
}

#logo-wrapper {
    margin: 13px 0;
    height: 36px;
    max-width: 650px;
    clip-path: polygon(0 0, 100% 0%, 95% 100%, 0% 100%);
    margin-left: 51px;

    #logo-lyra {
        max-width: 100%;
    }

    @media (max-width: 768px) {
        margin-left: 16px !important;
    }
}

#send-button {
    height: inherit;
    padding: 13px 0;
    .btn-enviar-trilha {
        margin-right: 27px;
        margin-left: auto;
        display: flex;
        align-items: center;

        @media (max-width: 768px) {
            margin-right: 13px;
        }
    }
    .el-button--primary {
        background: #43A349 !important;
    }
    .el-button--primary:hover {
        background: var(--secondary) !important;
    }
}

.username {
    color: var(--white);
    cursor: pointer;
    font-size: 14px;
}

.el-dropdown-link {
    display: flex;
    align-items: center;
}

.user-logo {
    color: var(--white);
    font-size: 28px;
    margin-right: 5px;
}

.icon-arrow-user {
    color: var(--white);
}

.sair {
    color: var(--primary);
}

#header-monitoramento {
    .flow {
        font-size: 20px;

        &.tilted {
            transform: rotate(45deg);
        }
    }
}

.box {
    display: flex;
    justify-content: center;
    height: 100%;
    min-width: 420px;

    .tipo {
        font-size: map-get($font-size, big);
        height: 100%;

        display: flex;
        justify-content: center;
        align-items: center;

        border-bottom: 2px solid transparent;

        color: var(--white);

        &.active {
            color: var(--secondary);
            border-bottom: 3px solid var(--secondary);

            h6 {
                font-weight: map-get($font-weight, medium);
            }

            i {
                color: var(--secondary);
            }
        }

        i {
            color: var(--disabled-font-color);
        }
    }

    .tipo.cultura {
        width: $width-box-tipo-cultura;
    }

    .tipo.area-monitorada {
        padding: 0 3%;
    }

    &.box-area-monitorada {
        .flow {
            font-size: 26px;
        }
    }
}

#logo-wrapper {
    height: 36px;
    max-width: 650px;
    clip-path: polygon(0 0, 100% 0%, 95% 100%, 0% 100%);
    margin-left: 51px;

    #logo-lyra {
        max-width: 100%;
    }
}

#logo-wrapper-bunge {
    height: 36px;
    max-width: 650px;
    margin-left: 30px;

    #logo-bunge {
        max-width: 100%;
        height: 36px;
    }
}

.language-code {
    font-size: 11px;
    margin-left: 5px;
    font-weight: bold;
}

#user-logged {
    color: var(--white);
    margin-right: 12px;
    display: flex;
    align-items: center;
    cursor: context-menu;

    span {
        font-size: 14px;
        margin-right: 4px;
    }
}

.action-button {
    cursor: pointer;
}
.dados_user {
    width: 110px;
    display: flex;
    flex-direction: column;
    align-items: left;

    .username {
        color: var(--white);
        cursor: pointer;
        font-size: 14px;
    }
    .empresa-selecionada {
        color: var(--white);
        max-width: 16ch;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        font-size: 12px;
    }
}
</style>
